export const isTouchScreen = () => window.matchMedia('(hover: none) and (pointer: coarse)').matches;
